import Exim from 'exim';
import _ from 'lodash';
import { observable } from 'mobx';
import Api from 'tm3-core/api';
import type { FolderTree } from 'tm3-core/api.dtos';
import lazy from './lazy-loader';

type TTemplate = {
  templates: FolderTree;
  filteredTemplates: FolderTree;
};

const TemplateObservable: TTemplate = observable({
  templates: {
    folders: [],
    files: []
  },
  filteredTemplates: {
    files: [],
    folders: []
  }
});

const Store = Exim.createStore({
  actions: [
    'setCurrent',
    'loadAll',
    'loadAttachments',
    'setTemplates',
    'delete',
    'rename',
    'copy',
    'reloadTemplates',
    'reset'
  ],
  initial: {
    loadingTemplates: true,
    templates: {
      folders: [],
      files: []
    },
    filteredTemplates: {
      folders: [],
      files: []
    }
  },

  setCurrent(name, filter) {
    return lazy('/api/templates').then((res) => {
      let filteredTemplates;
      const templatesFolder = res.body;
      if (name) {
        filteredTemplates = templatesFolder.folders.find((x) => x.name === name);
      }
      if (filteredTemplates) {
        this.set({ filteredTemplates });
        TemplateObservable.templates = res.body; // Handle refresh issue (legacy)
        TemplateObservable.filteredTemplates = filteredTemplates;
      }
    });
  },

  reloadTemplates() {
    lazy.clear('/api/templates');
    return this.actions.loadAll();
  },

  loadAll() {
    this.set({
      loadingTemplates: true
    });

    return lazy('/api/templates')
      .then((res) => {
        TemplateObservable.templates = res.body;
        return this.set({
          templates: res.body,
          loadingTemplates: false
        });
      })
      .catch(() => {
        return console.log('Error loadingTemplates templates');
      });
  },

  loadAttachments(mode) {
    this.set({
      loadingTemplates: true
    });

    return lazy('/api/templates')
      .then((res) => {
        return this.set({
          templates: res.body,
          loadingTemplates: false
        });
      })
      .catch(() => {
        return console.log('Error loadingTemplates templates');
      });
  },

  delete(path, isGlobal) {
    path = path.replace(/\\|\//g, '%2F');
    return Api.post('/api/delete', { path, isGlobal }).then((res) => {
      return this.actions.reloadTemplates();
    });
  },

  rename(path, newName, isGlobal) {
    if (isGlobal) {
      this.actions.rename(path, path + '.hidden');
    }
    path = path.replace(/\\|\//g, '%2F');
    newName = newName.replace(/\\|\//g, '%2F');
    return Api.post('/api/rename', { path, newName, overwrite: true, isGlobal }).then((res) => {
      return this.actions.reloadTemplates();
    });
  },

  copy(path, newName, isGlobal) {
    path = path.replace(/\\|\//g, '%2F');
    newName = newName.replace(/\\|\//g, '%2F');
    return Api.post('/api/copy', { path, newName, overwrite: true, isGlobal }).then((res) => {
      return this.actions.reloadTemplates();
    });
  }
});

// Store.TemplateObservable = TemplateObservable
// module.exports = Store

export default Store;
export { TemplateObservable };
